import { ReactElement, ReactNode } from 'react';

import { EquipmentTabsValues } from 'types';

interface TabPanelProps {
  path: EquipmentTabsValues;
  value: EquipmentTabsValues;
  children?: ReactNode;
}

export function TabPanel({ children, value, path }: TabPanelProps): ReactElement {
  return <div hidden={value !== path}>{value === path && <>{children}</>}</div>;
}
